import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export interface FavoritePayload {
    name: string,
    latitude: number | null,
    longitude: number | null,
    parent: string
}

/**
 * Repository for the admin city-favorite endpoints (backend `favorite` service).
 * The axios base URL already contains `/api`, so paths are relative to it.
 */
export default class FavoriteRepository extends EntityBaseRepository {
    public list(): Promise<AxiosResponse> {
        return this.axiosClient.get('favorite');
    }

    public create(payload: FavoritePayload): Promise<AxiosResponse> {
        return this.axiosClient.post('favorite', payload);
    }

    public update(id: string, payload: Partial<FavoritePayload>): Promise<AxiosResponse> {
        return this.axiosClient.patch(`favorite/${id}`, payload);
    }

    public delete(id: string): Promise<AxiosResponse> {
        return this.axiosClient.delete(`favorite/${id}`);
    }
}
